import { EmailPreviewModal } from '@Components/Mailing';
import { type ApiInvoice } from '@Model';
import { PrintOptionsModal } from '@Modules/Documents';
import { CashPaymentModal } from '@Modules/Orders';
import {
    type AsyncStateUpdate,
    ConfirmationModal,
    EnumMessageLevel,
    InputPromptModal,
} from '@synqo/frontend-component-library';
import { type InvoiceActions } from './useInvoiceActions';

// @ai-generated 2026-09-18T07:55:12+00:00 by philipp.kammerer@synqony.com using Claude Opus 5

interface IStateProps {
    actions: InvoiceActions;
    resourceLabel: string;
}

export function InvoiceStateModals({ actions, resourceLabel }: IStateProps) {
    return (
        <>
            <ConfirmationModal
                title={'Wirklich freigeben?'}
                message={
                    actions.isCancellation
                        ? `Wollen Sie die ${resourceLabel} wirklich freigeben? Nach der Freigabe kann die Storno nicht mehr gelöscht werden!`
                        : `Wollen Sie die ${resourceLabel} wirklich freigeben?`
                }
                messageLevel={EnumMessageLevel.Information}
                isOpen={actions.approvalModal.isOpen}
                onConfirm={actions.approveInvoice}
                onCancel={actions.approvalModal.close}
            />

            {actions.canCancel && (
                <InputPromptModal
                    name="CancellationModal"
                    value=""
                    label="Stornogrund"
                    title={'Wirklich stornieren?'}
                    message={'Bitte geben Sie den Grund für die Stornierung ein.'}
                    isOpen={actions.cancellationModal.isOpen}
                    confirm={{
                        variant: 'warning',
                        onClick: actions.confirmCancellation,
                    }}
                    onClose={actions.cancellationModal.close}
                    required
                />
            )}
        </>
    );
}

interface ICollectionProps {
    actions: InvoiceActions;
    invoice: ApiInvoice;
    requestUpdateState: AsyncStateUpdate<ApiInvoice>;
}

export function InvoiceCollectionModal({ actions, invoice, requestUpdateState }: ICollectionProps) {
    return (
        <CashPaymentModal
            type="invoice"
            entity={invoice}
            currency="€"
            totalGrossPrice={invoice.total_gross_price}
            isOpen={actions.cashPaymentModal.isOpen}
            close={actions.cashPaymentModal.close}
            onBeforeStartPayment={actions.approveInvoice}
            onSuccessfulPayment={(invoices) => {
                requestUpdateState(() => ({
                    data: invoices[0],
                    messages: [],
                }));
                actions.previewInvoice(invoice.id);
            }}
            requestUpdateState={requestUpdateState}
        />
    );
}

interface IOutputProps {
    actions: InvoiceActions;
    invoiceId: string;
}

export function InvoiceOutputModals({ actions, invoiceId }: IOutputProps) {
    const { printOptionsInfo } = actions;

    return (
        <>
            <PrintOptionsModal
                sendAsEmail={() => actions.prepareEmail({ invoice_id: invoiceId })}
                printOption={printOptionsInfo.currentPrintOption}
                onClose={() => printOptionsInfo.setCurrentPrintOption(undefined)}
            />
            <EmailPreviewModal
                isPreparing={actions.isPreparing}
                emailRequest={actions.emailRequest}
                setEmailRequest={actions.setEmailRequest}
                onEmailSent={actions.onEmailSent}
            />
        </>
    );
}
